// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-logo-enter{transition:all .5s ease;margin-bottom:-25px;opacity:0}.show-logo-enter-to{transition:all .5s ease;margin-bottom:0;opacity:1}.show-logo-leave{transition:all .5s ease;margin-top:0;opacity:1}.show-logo-leave-to{transition:all .5s ease;margin-top:-25px;opacity:0}", ""]);
// Exports
module.exports = exports;
